import { pick } from 'lodash';
import { useSelector } from 'react-redux';

import { appInfoSelector } from '@common/redux/selectors/app';
import { ITable } from '@common/types/index';
import { AppVersion } from 'click-types';

const createStyles = (attributes: ITable) => {
  const appInfo = useSelector(appInfoSelector);
  const isV4 = appInfo?.version === AppVersion.V4;

  let transform;
  if (attributes.style?.left === '50%') {
    transform = 'translateX(-50%)';
  }

  return {
    minHeight: attributes.height,
    width: attributes.style?.width || attributes.width,
    marginTop: attributes.marginTop,
    marginLeft: attributes.marginLeft,
    zIndex: attributes.zIndex,
    opacity: attributes.opacity,
    ...(isV4 &&
      pick(attributes.style, ['position', 'top', 'left', 'bottom', 'right'])),
    ...(isV4 && { transform }),
  };
};

export default createStyles;
